import { render, staticRenderFns } from "./SubAssistanceOverlay.vue?vue&type=template&id=79c4c070&scoped=true"
import script from "./SubAssistanceOverlay.vue?vue&type=script&lang=js"
export * from "./SubAssistanceOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4c070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c4c070')) {
      api.createRecord('79c4c070', component.options)
    } else {
      api.reload('79c4c070', component.options)
    }
    module.hot.accept("./SubAssistanceOverlay.vue?vue&type=template&id=79c4c070&scoped=true", function () {
      api.rerender('79c4c070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubAssistanceOverlay.vue"
export default component.exports